module.exports = {
        API_URL: 'https://vetopedia.org/api/',
        NOCO_DB_API_URL: 'https://noco.vetopedia.org/api/v2',
        NOCO_DB_MOBILFUNK_TABLE_ID: 'mbua09lpjrwbmts',
        NOCO_DB_MOBILFUNK_VIEW_ID: 'vwux2t5yuo7pvh9n',
        NOCO_DB_TOKEN: 'UX7NFNr4_NLDl74M8YfspoFJVrZkbeOZ5GyMvF7l'
}

